import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { CustomerUserSummary } from '@cdw-ae/common-data';
import type { ICdwSearchGridDataService } from '@cdw-ae/common-ui-components-search-grid';
import type {
  IGetSqlDataParams,
  SqlResponse,
} from '@cdw-ae/filter-bar-interfaces';
import type { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

/**
 * SSRM data source for the per-customer Users grid on the customer-detail page.
 * Mirrors {@link CustomersDataService} but is scoped to one tenant: the detail
 * component sets {@link customerId} before the grid renders, and each row block
 * is forwarded to `POST /platform/customers/:id/users/search`.
 *
 * Provided at the component level (not root) so the tenant id can't go stale
 * across customer-detail views.
 */
@Injectable()
export class CustomerUsersDataService
  implements ICdwSearchGridDataService<CustomerUserSummary>
{
  private readonly http = inject(HttpClient);

  /** Set by the customer-detail component before the grid loads. */
  customerId: number | null = null;

  fetchSqlData(
    params: IGetSqlDataParams
  ): Observable<SqlResponse<CustomerUserSummary>> {
    const { activeFilters, supplementalFilters, startRow, endRow, sortOrder } =
      params;
    return this.http.post<SqlResponse<CustomerUserSummary>>(
      `${environment.urls.backendApi}/platform/customers/${this.customerId}/users/search`,
      { activeFilters, supplementalFilters, startRow, endRow, sortOrder }
    );
  }
}
